export const PREOPCHECK_APP_NAME = 'jh-preopcheck'
export const PREOPCHECK_TILE_NAME = 'jh-preopcheck-tile'
